export const Marker = ({ fill, className, width }) => (
  <svg
    className={width}
    width={width ? 'auto' : 13}
    height={width ? 'auto' : 13}
    fill="none"
    viewBox="0 0 13 13"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      className={className}
      d="M12.75 2.57419V12.5871L6.61587 9.37848L6.5 9.31786L6.38413 9.37848L0.25 12.5871V2.57419L6.5 0.266497L12.75 2.57419Z"
      stroke="currentColor"
      fill={fill}
      strokeWidth="1"
    />
  </svg>
)
